import { Collapse, Flex, Text, HStack, Icon } from '@chakra-ui/react';

import { IoTimeOutline, IoChevronDownOutline } from 'react-icons/io5';

type OrderCollapseContainerProps = {
  isOpen?: boolean;
  orderNumber?: string;
  completeTimeString?: string;
  children?: React.ReactNode;
  onOpen: () => void;
};

export default function OrderCollapseContainer({
  isOpen,
  orderNumber = '',
  completeTimeString = '',
  children,
  onOpen,
}: OrderCollapseContainerProps) {
  return (
    <Flex direction="column" align="stretch">
      <Flex
        p={2}
        align="center"
        justify="space-between"
        bgColor="secondary"
        borderTopRadius="5px"
        cursor="pointer"
        onClick={onOpen}
      >
        <Text color="white" fontSize="sm" whiteSpace="nowrap">
          訂單編號-<b>{orderNumber}</b>
        </Text>

        <HStack>
          <Text whiteSpace="nowrap" color="primaryLight" fontSize="xs">
            {isOpen ? '收起明細' : '展開明細'}
          </Text>
          <Icon
            color="primaryLight"
            as={IoChevronDownOutline}
            transition="0.3s"
            transform={`rotateX(${isOpen ? -180 : 0}deg)`}
          />
        </HStack>
      </Flex>

      <Collapse in={isOpen}>{children}</Collapse>

      {!isOpen && (
        <HStack p={2} borderBottomWidth="1px" borderColor="secondary">
          <Icon as={IoTimeOutline} color="secondary" />
          <Text fontSize="xs" color="secondary">
            預計完成時間 {completeTimeString}
          </Text>
        </HStack>
      )}
    </Flex>
  );
}
